export enum DiagnosisCategory {
  IBD = 'IBD',
  IBS = 'IBS',
  Other = 'Other',
  UpperGI = 'Upper GI',
}

export type Diagnosis = {
  id: string;
  diagnosis: string;
  category?: DiagnosisCategory;
};

export interface UserDiagnosis extends Diagnosis {
  dx_id: string;
  sort_order: number | null;
}

export type ChartNote = {
  is_locked: boolean | null;
  is_signed: boolean | null;
  note_id: string | null;
  note_label?: string | null;
  note_type: string;
  note_url: string | null;
};

export enum ProviderType {
  Coach = 'Coach',
  Pharmacist = 'Pharmacist',
  Provider = 'Provider',
  Dietitian = 'Dietitian',
}

// The status of the meeting
export enum PmStatus {
  occurred = 'Occurred',
  cancelled = 'Cancelled',
  lateCancelled = 'Late Cancellation',
  noShow = 'No-Show',
  rescheduled = 'Re-Scheduled',
}

export enum SupervisorStatus {
  supervised = 'supervised',
  supervising = 'supervising',
}

type Provider = {
  id: number;
  display_name: string;
  full_name: string;
  healthie_id: number;
  image_url: string;
  status: string;
  supervisor_status: SupervisorStatus | null;
  type: ProviderType;
};

export type MeetingNote = {
  charting_note_url: string | null;
  chart_notes?: ChartNote[];
  client_confirmed: boolean;
  healthie_appointment_id: number;
  meeting_date: string;
  meeting_type: string | null;
  metadata: any;
  pm_status: PmStatus;
  provider?: Provider;
  zoom_join_url: string | null;
  zoom_start_url: string | null;
};
